module.exports = __webpack_public_path__ + "img/GAME_BEAUTIFULFLOWER.c5dd112c.png";